export default {
  "content": "<path fill=\"#444\" d=\"M7.767 5.345A2.651 2.651 0 0110.667 8 2.667 2.667 0 018 10.666a2.651 2.651 0 01-2.656-2.9c.259.125.559.233.878.233A1.78 1.78 0 008 6.222c0-.32-.108-.62-.233-.878zm5.583-1.328c1.3 1.205 2.17 2.625 2.58 3.641a.884.884 0 010 .684c-.41.991-1.28 2.41-2.58 3.641-1.308 1.217-3.106 2.24-5.35 2.24-2.244 0-4.042-1.023-5.35-2.24-1.3-1.23-2.168-2.65-2.582-3.641a.888.888 0 010-.684c.414-1.016 1.283-2.436 2.583-3.641C3.958 2.8 5.756 1.777 8 1.777s4.042 1.024 5.35 2.24zM8 4a4.001 4.001 0 000 8 4.001 4.001 0 000-8z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};